import React, { useState } from 'react';
import { FiCornerUpLeft, FiMail } from 'react-icons/fi';
import type { ContactEmailItem } from '../../services/ContactEmailService';
import './emailConversation.css';

const LONG_TEXT = 700;

interface Props {
  email: ContactEmailItem;
  formatTime: (iso: string) => string;
  onReply?: (email: ContactEmailItem) => void;
}

/** E-mail na linha do tempo do cliente: ícone do canal, assunto e o texto (sem HTML). */
export const EmailTimelineBubble: React.FC<Props> = ({ email, formatTime, onReply }) => {
  const [expanded, setExpanded] = useState(false);
  const outgoing = email.direction === 'out';
  const long = email.text.length > LONG_TEXT;
  const text = long && !expanded ? `${email.text.slice(0, LONG_TEXT).trimEnd()}…` : email.text;

  return (
    <div className={`email-bubble ${outgoing ? 'email-bubble-out' : 'email-bubble-in'}`} data-testid="email-bubble">
      <div className="email-bubble-card">
        <div className="email-bubble-head">
          <span className="email-bubble-channel" title="Mensagem por e-mail">
            <FiMail size={13} aria-hidden="true" /> E-mail
          </span>
          <span className="email-bubble-who">{outgoing ? `Para ${email.to}` : `De ${email.from}`}</span>
        </div>
        <div className="email-bubble-subject">{email.subject || '(sem assunto)'}</div>
        {text ? <div className="email-bubble-text">{text}</div> : <div className="email-bubble-text email-bubble-empty">(e-mail sem texto)</div>}
        {long && (
          <button type="button" className="email-bubble-link" onClick={() => setExpanded((v) => !v)}>
            {expanded ? 'Mostrar menos' : 'Ver e-mail completo'}
          </button>
        )}
      </div>
      <div className="email-bubble-info">
        <span>{formatTime(email.at)}</span>
        {email.sentFromConversation && <span className="email-bubble-tag">enviado pela conversa</span>}
        {!outgoing && onReply && (
          <button type="button" className="email-bubble-link" onClick={() => onReply(email)}>
            <FiCornerUpLeft size={12} aria-hidden="true" /> Responder por e-mail
          </button>
        )}
      </div>
    </div>
  );
};
